
<div *ngIf="this.httpService.showLoading" [hidden]="!this.httpService.showLoading" class="modal">
  <div data-testid="full_screen_spinner" class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/spinnerLoading/spinnerLoading.component.ts.SpinnerLoadingComponent.html